
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2011_57126)"}},[_c('path',{attrs:{"d":"M15.58 2.96a1.342 1.342 0 00-1.014-.46H12.62v-.667C12.62 1.1 12.02.5 11.286.5H4.62c-.734 0-1.334.6-1.334 1.333V2.5H1.34c-.387 0-.76.167-1.014.46a1.323 1.323 0 00-.313 1.053 6.015 6.015 0 003.693 4.714l.2.08a4.7 4.7 0 002.047 1.9V12.5h-.667c-.733 0-1.333.6-1.333 1.333V16.5h8v-2.667c0-.733-.6-1.333-1.333-1.333h-.667v-1.793A4.664 4.664 0 0012 8.807l.2-.08a6.015 6.015 0 003.693-4.714c.053-.38-.06-.76-.313-1.053zM3.286 6.993a4.659 4.659 0 01-1.946-3.16h1.946v3.16zm9.334 0V3.827h1.953a4.681 4.681 0 01-1.953 3.166z","fill":"#F9A91E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2011_57126"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    